import { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

/* ──────────────────────────────────────────────────────────────────────── */
const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(ellipse 60% 50% at 50% 0%, #eef2ff 0%, transparent 70%),
    #ffffff;
  font-family: "Pretendard Variable", Pretendard, -apple-system,
    BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: 32px;
`;

const Card = styled.form`
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  box-shadow: 0 24px 60px -32px rgba(15, 23, 42, 0.18);
`;

const Eyebrow = styled.p`
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6366f1;
  margin: 0;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin: 0;
`;

const Lead = styled.p`
  font-size: 14.5px;
  line-height: 1.6;
  color: #64748b;
  margin: 0;
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .label {
    font-size: 12.5px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  font-size: 15px;
  color: #0f172a;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: #94a3b8;
  }

  &:focus {
    outline: 0;
    border-color: #c7d2fe;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.08);
  }
`;

const SubmitBtn = styled.button`
  padding: 12px 20px;
  border-radius: 12px;
  border: 0;
  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 10px 22px -10px rgba(99, 102, 241, 0.55);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 14px 28px -10px rgba(99, 102, 241, 0.7);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const ErrorText = styled.p`
  margin: 0;
  font-size: 13.5px;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 10px 14px;
`;

const HomeLink = styled.a`
  font-size: 13px;
  color: #94a3b8;
  text-decoration: none;
  text-align: center;
  transition: color 0.15s ease;

  &:hover {
    color: #475569;
  }
`;

export function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    const expected = process.env.REACT_APP_ADMIN_PASSWORD;

    if (!expected) {
      setError(
        "Admin password is not configured. Set REACT_APP_ADMIN_PASSWORD in .env"
      );
      setSubmitting(false);
      return;
    }

    if (password === expected) {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userName", "admin");
      navigate("/adminWrite");
    } else {
      setError("Incorrect password. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <Page>
      <Card onSubmit={handleSubmit}>
        <div>
          <Eyebrow>Youngand admin</Eyebrow>
          <Title>Sign in</Title>
        </div>
        <Lead>Enter the admin password to manage site content.</Lead>

        <Field>
          <span className="label">Password</span>
          <Input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </Field>

        {error && <ErrorText>{error}</ErrorText>}

        <SubmitBtn type="submit" disabled={submitting || !password}>
          {submitting ? "Signing in…" : "Sign in"}
        </SubmitBtn>

        <HomeLink href="/">← Back to home</HomeLink>
      </Card>
    </Page>
  );
}
